<template>
	<div class="display-flex flex-row flex-align-center flex-justify-space-between width-100">
		<div class="map-connection-text">{{ title }}</div>
		<div class="link-text" @click="$emit('change-mapping')" v-if="allowChange">Change mapping</div>
	</div>
</template>

<script>
export default {
	name: 'MappingInterfaceFieldHeader',
	props: {
		title: { type: String },
		allowChange: { type: Boolean },
	},
};
</script>

<style lang="scss" scoped>
.link-text {
	opacity: 0.5;
	font-size: 12px;
	cursor: pointer;
	text-align: right;
	text-decoration: underline;
	color: var(--profile-selection-grey);
}
.map-connection-text {
	font-size: 12px;
	color: var(--primary-font-color);
}
</style>
